module.exports = __webpack_public_path__ + "static/media/on_one.536a69d6.png";